// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePrescriberModel {
    static getAttributeTypeMap() {
        return SimpleIntakePrescriberModel.attributeTypeMap;
    }
}
SimpleIntakePrescriberModel.discriminator = undefined;
SimpleIntakePrescriberModel.additionalProperties = false;
SimpleIntakePrescriberModel.attributeTypeMap = [
    {
        "name": "dea",
        "baseName": "dea",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "phones",
        "baseName": "phones",
        "type": "SimpleIntakePrescriberPhonesModel"
    },
    {
        "name": "stateLicense",
        "baseName": "stateLicense",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=simpleIntakePrescriberModel.js.map